import { render, staticRenderFns } from "./CalendarEventPage.vue?vue&type=template&id=c4ccd1c4&scoped=true&lang=pug&"
import script from "./CalendarEventPage.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventPage.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventPage.vue?vue&type=style&index=0&id=c4ccd1c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ccd1c4",
  null
  
)

export default component.exports